'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Review = undefined;

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _StarRating = require('../StarRating/StarRating');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Review = exports.Review = function Review(_ref) {
  var createdOn = _ref.createdOn,
      nameOfClass = _ref.nameOfClass,
      studioResponse = _ref.studioResponse,
      teacherName = _ref.teacherName,
      rating = _ref.rating,
      review = _ref.review;
  return _react2.default.createElement(
    'div',
    { className: 'review__single' },
    _react2.default.createElement(
      'time',
      null,
      _react2.default.createElement(_reactIntl.FormattedRelative, { value: createdOn })
    ),
    rating && _react2.default.createElement(_StarRating.StarRating, { rating: parseInt(rating, 10), className: 'mb-' }),
    _react2.default.createElement(
      'h5',
      null,
      teacherName ? _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'review.title',
        defaultMessage: '{nameOfClass} with {teacherName}',
        values: { nameOfClass: nameOfClass, teacherName: teacherName }
      }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'review.title-no-teacher',
        defaultMessage: '{nameOfClass}',
        values: { nameOfClass: nameOfClass }
      })
    ),
    _react2.default.createElement(
      'div',
      null,
      review
    ),
    studioResponse && _react2.default.createElement(
      'div',
      { className: 'review__single__response' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        tagName: 'strong',
        id: 'review.response.title',
        defaultMessage: 'Response from the studio:'
      }),
      _react2.default.createElement(
        'div',
        { className: 'text--light' },
        studioResponse
      )
    )
  );
};

Review.propTypes = {
  createdOn: _propTypes2.default.object.isRequired,
  nameOfClass: _propTypes2.default.string.isRequired,
  studioResponse: _propTypes2.default.string,
  teacherName: _propTypes2.default.string,
  rating: _propTypes2.default.number,
  review: _propTypes2.default.string.isRequired
};